'use client'

import { Drawer as _Drawer, DrawerProps as _DrawerProps } from 'antd'
import { Icon } from 'shared/iconpack'
import { lockScroll } from 'shared/libs/lockScroll'
import { clsx } from 'shared/libs/style-merge'

import { useEffect } from 'react'

import { globalStyles } from 'shared/config/styles/globalStyles'

import styles from './Drawer.module.scss'

type DrawerProps = _DrawerProps & {
  type?: 'primary' | 'secondary' | 'extra'
  withoutRadius?: boolean
  withCloseIcon?: boolean
}

export function Drawer({
  className,
  type = 'primary',
  withoutRadius = false,
  withCloseIcon = true,
  ...props
}: DrawerProps) {
  useEffect(() => {
    lockScroll(props.open)
    return () => lockScroll(false)
  }, [props.open])

  return (
    <_Drawer
      className={clsx(className, styles.drawer, styles[type], {
        [styles.withoutRadius]: withoutRadius,
      })}
      closeIcon={
        withCloseIcon && (
          <Icon name="close" color={globalStyles['--icon-primary']} size={20} />
        )
      }
      getContainer={() => {
        const shadowRoot = document.querySelector('mkassa-widget')?.shadowRoot
        return (shadowRoot as unknown as HTMLElement) || document.body
      }}
      zIndex={Number(globalStyles['--zIndex-drawer'])}
      placement="bottom"
      height={'auto'}
      {...props}
    />
  )
}
